import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppState {
  public isInErrorState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isAuthenticated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public searchIsExpanded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public cssVarCompMainMarginTop: number;
  public cssVarListUnitHeaderTop: number;
  public cssVarListUnitHeaderTranslateX: number;
  public cssVarListUnitHeaderTranslateY: number;
}
